import { render, staticRenderFns } from "./wxwl-xm.vue?vue&type=template&id=7da7dcb8&scoped=true"
import script from "./wxwl-xm.vue?vue&type=script&lang=js"
export * from "./wxwl-xm.vue?vue&type=script&lang=js"
import style0 from "./wxwl-xm.vue?vue&type=style&index=0&id=7da7dcb8&prod&lang=css"
import style1 from "./wxwl-xm.vue?vue&type=style&index=1&id=7da7dcb8&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da7dcb8",
  null
  
)

export default component.exports